import { ICalendarDateRange } from '@models';
import { useStore } from '@stores';
import { useEffect, useState } from 'react';

declare let abp: any;

interface IProps {
  userId?: number;
}

export const useCalendarOrders = ({ userId }: IProps) => {
  const { orderStore } = useStore();
  const { calendarOrderList, calendarLoading } = orderStore;
  const [eventsDate, setEventsDate] = useState<ICalendarDateRange>();

  useEffect(() => {
    eventsDate && orderStore.getCalendarItems({ ...eventsDate });
  }, [orderStore, eventsDate, userId]);

  return {
    calendarItems: calendarOrderList,
    eventsDate,
    calendarLoading,
    setEventsDate,
  };
};
